import { render, staticRenderFns } from "./EditProfQualDetails.vue?vue&type=template&id=f00fd4bc&scoped=true"
import script from "./EditProfQualDetails.vue?vue&type=script&lang=js"
export * from "./EditProfQualDetails.vue?vue&type=script&lang=js"
import style0 from "./EditProfQualDetails.vue?vue&type=style&index=0&id=f00fd4bc&prod&scoped=true&lang=css"
import style1 from "./EditProfQualDetails.vue?vue&type=style&index=1&id=f00fd4bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f00fd4bc",
  null
  
)

export default component.exports